import { underlineLinkStyle, crudAdStyle, helpbuttonStyle } from '@bingads-webui-campaign-react/common-styles';

import broadMatchModifierImg from '../media/tipsOpportunities/tips/broad_match_modifier.svg';
import callImg from '../media/tipsOpportunities/tips/call.svg';
import calloutExtensionsImg from '../media/tipsOpportunities/tips/callout_extensions.svg';
import convTrackingImg from '../media/tipsOpportunities/tips/conv_tracking.svg';
import createCampaignImg from '../media/tipsOpportunities/tips/create_campaign.svg';
import dynamicSearchAdsImg from '../media/tipsOpportunities/tips/dynamic_search_ads.svg';
import enhancedCpcAutobidImg from '../media/tipsOpportunities/tips/enhanced_cpc_autobid.svg';
import expandedTextAdsImg from '../media/tipsOpportunities/tips/expanded_text_ads.svg';
import googleImportImg from '../media/tipsOpportunities/tips/google_import.svg';
import kwMatchTypesImg from '../media/tipsOpportunities/tips/KW_match_types.svg';
import microsoftLogoImg from '../media/tipsOpportunities/tips/microsoft_logo.svg';
import negKeywordsImg from '../media/tipsOpportunities/tips/neg_keywords.svg';
import remarketingImg from '../media/tipsOpportunities/tips/remarketing.svg';
import reviewExtentionsImg from '../media/tipsOpportunities/tips/review_extentions.svg';
import sharedBudgetsImg from '../media/tipsOpportunities/tips/shared_budgets.svg';
import sitelinkExtensionsImg from '../media/tipsOpportunities/tips/sitelink_extensions.svg';
import structuredSnippetsImg from '../media/tipsOpportunities/tips/structured_snippets.svg';
import welcomeAddPaymentImg from '../media/tipsOpportunities/tips/welcome_add_payment.svg';
import welcomeCoachingImg from '../media/tipsOpportunities/tips/welcome_coaching.svg';
import welcomeCouponImg from '../media/tipsOpportunities/tips/welcome_coupon.svg';
import welcomeHelpImg from '../media/tipsOpportunities/tips/welcome_help.svg';
import addNewAdsImg from '../media/tipsOpportunities/opportunities/AddNewAds.svg';
import addNewKeywordImg from '../media/tipsOpportunities/opportunities/AddNewKeyword.svg';
import adSchedulingImg from '../media/tipsOpportunities/opportunities/AdScheduling.svg';
import budgetOppoImg from '../media/tipsOpportunities/opportunities/BudgetOppo.svg';
import calloutExtensionImg from '../media/tipsOpportunities/opportunities/CalloutExtension.svg';
import competitiveBidImg from '../media/tipsOpportunities/opportunities/CompetitiveBid.svg';
import firstpageOppoImg from '../media/tipsOpportunities/opportunities/FirstpageOppo.svg';
import firstPositionImg from '../media/tipsOpportunities/opportunities/FirstPosition.svg';
import googleAdImportImg from '../media/tipsOpportunities/opportunities/GAImport.svg';
import keywordBidImg from '../media/tipsOpportunities/opportunities/KeywordBid.svg';
import kwBroadMatchImg from '../media/tipsOpportunities/opportunities/KWBroadMatch.svg';
import kwBroadMatchModifierImg from '../media/tipsOpportunities/opportunities/KWBroadMatchModifier.svg';
import locationBidImg from '../media/tipsOpportunities/opportunities/LocationBid.svg';
import mainlineOppoImg from '../media/tipsOpportunities/opportunities/MainlineOppo.svg';
import remarketingBidImg from '../media/tipsOpportunities/opportunities/RemarketingBid.svg';
import sitelinkExtensionImg from '../media/tipsOpportunities/opportunities/SitelinkExtension.svg';

const tagHeight = 24;
const flyoutOffset = 16;

const couponFlyout = {
  '.flyout-popup-class-position': {
    zIndex: 5,
    '& .popover-view__dismiss': {
      display: 'none',
    },
    '&.right': {
      transform: 'translateX(15px)',
      '& .coupon-tag-flyout-content': {
        '&:after, &:before': {
          right: '100%',
        },
        '&:after': {
          borderColor: ['transparent', 'white', 'transparent', 'transparent'],
          marginRight: -2,
        },
        '&:before': {
          borderColor: ['transparent', 'lightgrey', 'transparent', 'transparent'],
        },
      },
    },
    '&.left': {
      transform: 'translateX(-15px)',
      '& .coupon-tag-flyout-content': {
        '&:after, &:before': {
          left: '100%',
        },
        '&:after': {
          borderColor: ['transparent', 'transparent', 'transparent', 'white'],
          marginLeft: -2,
        },
        '&:before': {
          borderColor: ['transparent', 'transparent', 'transparent', 'lightgrey'],
        },
      },
    },
    '& .flyout-popup-class': {
      marginTop: -flyoutOffset - tagHeight,
      '& .coupon-tag-flyout': {
        '& .coupon-tag-flyout-content': {
          backgroundColor: 'white',
          border: '1px solid lightgrey',
          padding: 10,
          color: 'black',
          width: 280,
          boxShadow: '3px 3px 4px #dddddd',
          '&:after, &:before': {
            top: -(tagHeight / 2),
            borderStyle: 'solid',
            content: '" "',
            height: 0,
            width: 0,
            position: 'absolute',
            pointerEvents: 'none',
          },
          '&:after': {
            borderWidth: 10.5,
            marginTop: -10.5,
          },
          '&:before': {
            borderWidth: 11,
            marginTop: -10,
          },
          '& .coupon-tag-flyout-line1': {
            fontWeight: 'bold',
          },
          '& .coupon-tag-flyout-line2': {
            color: 'red',
            marginBottom: 0,
          },
        },
      },
    },
  },
};

export const getTipCardStyle = palette => ({
  ...couponFlyout,
  '.tips-card-plus-fac': {
    position: 'relative',
    display: 'flex',
  },
  // estimates tile
  '.recommendation-estimation-tile': {
    fontSize: '12px',
    lineHeight: '15px',
    fontFamily: "'Segoe UI', Arial, sans-serif",
    display: '-ms-grid',
    '&.neutral-estimate': {
      color: 'gray',
      fontSize: 28,
    },
    '& .positive-estimate': {
      color: '#107C10',
      fontSize: 28,
    },
    '& .estimate-second-primary': {
      marginTop: '10px',
      '& .estimate-second-primary-titile': {
        width: '124px',
        lineHeight: '15px',
        fontWeight: 'bold',
        MsGridRow: 1,
        gridRow: 1,
      },
      '& .estimate-second-primary-increase': {
        width: '124px',
        lineHeight: '36px',
        fontWeight: 'bold',
        MsGridRow: 2,
        gridRow: 2,
      },
    },
    '& .estimate-primary-titile': {
      width: '124px',
      lineHeight: '15px',
      fontWeight: 'bold',
      MsGridRow: 1,
      gridRow: 1,
      fontSize: '12px !important',
    },
    '& .estimate-primary-increase': {
      width: '124px',
      lineHeight: '36px',
      fontWeight: 'bold',
      MsGridRow: 2,
      gridRow: 2,
      '& .recommendation-arrow-icon': {
        top: '10px',
        position: 'relative',
        '&:before': {
          fontSize: '20px!important',
        },
      },
    },
    '& .estimate-primary-from-to': {
      fontSize: '12px',
      lineHeight: '15px',
      width: '126px',
      whiteSpace: 'pre-wrap',
      MsGridRow: 3,
      gridRow: 3,
      color: 'gray',
    },
    '& .estimate-secondary': {
      margin: '8px 0 0 0',
      fontSize: '12px',
      lineHeight: '15px',
      MsGridRow: 4,
      gridRow: 4,
      '.estimate-secondary-value': {
        fontWeight: 'bold',
      },
      '.estimate-secondary-title': {
        fontWeight: 'normal',
      },
    },
    '& .estimate-tertiary': {
      fontSize: '12px',
      lineHeight: '15px',
      MsGridRow: 5,
      gridRow: 5,
      '& .estimate-tertiary-value': {
        fontWeight: 'normal',
      },
      '& .estimate-tertiary-title': {
        fontWeight: 'normal',
      },
    },
    '& .estimate-cost': {
      fontSize: '12px',
      lineHeight: '15px',
      color: 'black',
      MsGridRow: 6,
      gridRow: 6,
      '& .estimate-cost-value': {
        fontWeight: 'normal',
      },
      '& .estimate-cost-title': {
        fontWeight: 'normal',
      },
    },
    '& .estimate-note': {
      margin: '8px 0 0 0',
      fontSize: '12px',
      lineHeight: '15px',
      MsGridRow: 7,
      gridRow: 7,
      color: 'gray',
    },
  },
  '& .summary-header-menu .bingads-popover': {
    right: 5,
  },
  '& >.toolbar': {
    marginLeft: 10,
    '& .upper-toolbar': {
      display: 'inline-block',
    },
  },
  '& .empty-buttons': {
    marginTop: 36,
  },

  // empty view
  '& .empty-filter-view': {
    margin: '160px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .empty-icon': {
      display: 'inline-block',
      marginRight: 62,

      img: {
        width: 200,
        height: 200,
      },
    },

    '& .empty-details': {
      display: 'inline-block',
      color: '#605E5C',
      gridRow: '1',
      gridColumn: '2',
      '& .empty-title': {
        fontSize: 26,
        margin: '0 0 8.5px',
      },
      '& .empty-sub-title': {
        fontSize: 14,
        fontWeight: 'normal',
        ...underlineLinkStyle({ palette }),
      },
    },
  },

  '.recommendation-summary-card': {
    height: '278px',
    width: '100%',
    fontFamily: '\'Segoe UI\', Arial, sans-serif',
    fontSize: 12,
    display: 'grid',
    color: '#333333',
    gridTemplateColumns: '100%',
    gridTemplateRows: 'repeat(4,auto)',
    '& .summary-summary': {
      gridRow: '1',
      gridTemplateRows: 'repeat(2,auto)',
      '& .summary-notification': {
        '& .recommendation-notification-container': {
          background: '#EFF6FC !important',
          display: 'flex',
          '& .recommendation-notification-text': {
            maxWidth: '90%',
            padding: '5px 0 5px 24px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '& .recommendation-notification-help': {
            maxWidth: '10%',
            padding: '5px 10px 5px 0',
          },
        },
        '& .helpbutton': helpbuttonStyle({ palette })['.helpbutton'],
        '& .helpbutton::before': { ...helpbuttonStyle({ palette })['.helpbutton::before'], top: 0 },
      },
      '& .summary-banner': {
        background: '#DDDDDD',
        gridRow: '1',
        '& .summary-banner-title': {
          display: 'table-cell',
          verticalAlign: 'middle',
          fontWeight: 'bold',
          color: '#333333',
          height: 30,
          padding: '0px 24px',
        },
      },
      '& .summary-summary-content': {
        borderBottom: 'solid 1px #dddddd',
        paddingTop: 16,
        paddingBottom: 12,
        display: 'grid',
        gridRow: '3',
        '& .summary-card-os-tag-container': {
          display: 'inline-block',
          marginLeft: 3,
          '& .not-available-line': {
            paddingLeft: 10,
            paddingRight: 10,
          },
          '& .iconba.iconba-Trending12': {
            paddingLeft: 8,
            paddingRight: 8,
            paddingBottom: 3,
          },
        },
        '& .summary-info': {
          gridColumn: '3',
          maxHeight: '164px',
          overflowY: 'auto',

          '& .summary-description': {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#323130',
          },
          '& .summary-description-os': {
            display: 'inline',
          },
          '& .summary-pitching': {
            fontSize: 12,
            fontWeight: 'normal',
            color: '#484644',
            marginTop: 10,
            '& > span': {
              ...underlineLinkStyle({ palette }),
            },
          },
        },
      },
      '& .summary-estimates': {
        gridColumn: '1',
      },
      '& .summary-overall-optimization-score': {
        gridColumn: '1',
        width: 124,
        '& .overall-optimization-score-number': {
          fontSize: 32,
          color: palette.blue,
          width: 124,
          gridRow: 2,
          fontWeight: 'bold',
        },
      },
    },
    '& .summary-sample': {
      gridRow: '2',
      overflowY: 'hidden',
      '&:hover ': {
        overflowY: 'auto',
      },
      '& .recommendation-sample': {
        '& .sample-insight-title': {
          marginTop: 8,
          fontSize: 13,
          fontWeight: 'normal',
          color: '#333333',
        },
        '& .sample-insight': {
          margin: '10px 0 0 0',
          fontSize: 13,
          fontWeight: 'normal',
          color: '#666666',
        },
        '& .sample-visual, & .sample-action-table': {
          margin: '8px 0 0 0',
        },
        '& .sample-horizontal-separator': {
          margin: '8px 0',
          borderTop: '1px solid #ececec',
        },
        '& .sample-action-title': {
          fontSize: 13,
          fontWeight: 'normal',
          color: '#333333',
        },
        '& .sample-more-recommendations': {
          margin: '8px 0 0 0',
        },
      },
      ...crudAdStyle({ palette }),
      '& .ad-preview-header': {
        padding: '0px 0 8px 0',
      },
      '& .recommendation-suggested-ads-column': {
        '& .recommendation-summary-ad-preview': {
          width: '100%',
          padding: '15px 15px 15px 15px',
          background: palette.white,
          border: 'solid 1px #dddddd',
        },
      },
    },
    '& .summary-footer': {
      bottom: '0px',
      position: 'absolute',
      gridRow: '4',
      '& .primary-button': {
        '& button': {
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontWeight: 'bold',
          fontSize: 13,
          backgroundColor: palette.themePrimary,
          color: palette.white,
          padding: '5px 10px',
          border: '1px black solid',
          margin: '0 8px 0 0',
          '&:hover': {
            backgroundColor: '#006464',
          },
        },
      },
      '& .secondary-button': {
        '& button': {
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontWeight: 'bold',
          fontSize: 13,
          backgroundColor: palette.white,
          color: '#000000',
          padding: '5px 10px',
          border: '1px black solid',
          margin: '0 8px 0 0',
          '&:hover': {
            backgroundColor: '#a8a8a8',
          },
        },
      },
    },
  },
  '.carousel-footer': {
    '& .btn-default': {
      display: 'none',
    },
    '& .btn-primary': {
      fontWeight: 'bold',
      fontSize: 14,
      height: '32px',
      backgroundColor: palette.white,
      color: palette.black,
      padding: '6px 19px',
      borderRadius: '2px',
      border: '1px solid black',
      minWidth: '212px',
      '&:hover': {
        backgroundColor: '#f3f2f1',
      },
    },
  },
  // recommendation visual
  '.action-table': {
    marginTop: 8,
    fontFamily: '\'Segoe UI\', Arial, sans-serif',
    '& thead': {
      '& th': {
        fontSize: 12,
        color: '#323130',
        fontWeight: 'bold',
        paddingRight: '10px',
        paddingBottom: '8px',
        '&:last-child': {
          paddingRight: '0px',
        },
      },
    },
    '& tbody': {
      '& th': {
        fontSize: 12,
        color: '#323130',
      },
    },
    '& td': {
      fontSize: 12,
      fontWeight: 'normal',
      color: '#333333',
      paddingBottom: 3,
      verticalAlign: 'top',
      paddingRight: '10px',
      'word-break': 'break-word',
      '&:last-child': {
        paddingRight: '0px',
      },
      '& .progress-bar-with-right-label': {
        marginLeft: 10,
        gridTemplateColumns: '80% 20%',
        alignItems: 'center',
        '& .progress': {
          marginRight: 5,
          gridRow: '1',
          gridColumn: '1',
        },
        '& .right-label': {
          gridRow: '1',
          gridColumn: '2',
        },
      },
    },
  },
  '& .navbar-nav': {
    '& .recommendation-download': {
      paddingLeft: 20,
      paddingTop: 6,
      marginBottom: '-15px',
      '& #button-download': {
        background: '#FFFFFF',
        border: '1px solid #8A8886',
        boxSizing: 'border-box',
        borderRadius: '2px',
        fontSize: '14px',
        marginLeft: '770px',
        zIndex: '1',
      },
    },
  },
  '& .nav-pills': {
    '& li': {
      border: '1px solid #505050',
      '&.active, &.active a': {
        backgroundColor: '#e7f0f6',
        color: '#666',
        fontWeight: 'bold',
      },
      '&:nth-child(1)': {
        borderRight: '0',
      },
      '& a': {
        padding: '5px 20px 4px 20px',
        border: 'none',
        fontWeight: 'normal',
      },
    },
  },
  '& .filter-editor': {
    '& .selector-container': {
      '& button': {
        border: '1px solid #BBB',
        padding: '3px 5px 5px 5px',
        textAlign: 'right',
      },
    },
    '& .selector-v2': {
      width: 400,
    },
  },
  '.card-holder__wrapper .tipsCarousel [class*="carousel-control"]': {
    backgroundImage: 'none',
    filter: 'none !important',
    width: 20,
    opacity: '1',
    margin: 0,
    cursor: 'default',
    top: 'auto',
    bottom: '16px',
    fontSize: '16px',
    height: '16px',
  },
  '.card-holder__wrapper .carousel-control': {
    backgroundColor: 'white',
    textShadow: 'none',
    color: palette.themePrimary,

    '&:hover': {
      color: palette.themeDarker,
    },
  },
  '.card-holder__wrapper .carousel-control.left': {
    left: 'auto',
    right: '30px',
  },
  '.card-holder__wrapper .carousel-control .carousel-control__arrow-right': {
    width: 16,
    height: 16,
    cursor: 'pointer',
    bottom: 'auto',
    '&:before': {
      fontFamily: '"MsAds MDL2 Assets"',
      content: '"\\E76C"',
    },
  },
  '.card-holder__wrapper .carousel-control .carousel-control__arrow-left': {
    width: 16,
    height: 16,
    cursor: 'pointer',
    bottom: 'auto',
    '&:before': {
      fontFamily: '"MsAds MDL2 Assets"',
      content: '"\\E76B"',
    },
  },
  '.card-holder__wrapper .carousel-control.clickable:focus:after': {
    border: 'none',
    outline: `1px solid ${palette.neutralSecondary}`,
    outlineOffset: 2,
  },
  '.card-holder__wrapper .carousel-indicators': {
    marginBottom: '0',
    height: 8,
    bottom: '16px',
    left: '0px',
    width: 'auto',
    margin: '0px',
    lineHeight: '8px',
    fontSize: '8px',
  },
  '.card-holder__wrapper .carousel-indicators li': {
    height: 8,
    width: 8,
    margin: '0',
    marginRight: 10,
    background: 'none',
    border: `1px solid ${palette.neutralSecondary}`,

    '@media screen and (forced-colors: active)': {
      forcedColorAdjust: 'none',
    },

    '@media screen and (-ms-high-contrast: active)': {
      background: 'window',
      borderColor: 'windowtext',
    },
  },
  '.card-holder__wrapper .carousel-indicators .active': {
    margin: '0',
    marginRight: 10,
    border: 'none',
    background: palette.themePrimary,

    '@media screen and (forced-colors: active)': {
      forcedColorAdjust: 'none',
    },

    '@media screen and (-ms-high-contrast: active)': {
      background: 'highlight',
    },
  },
  '.card-holder__wrapper .import_tip_img': {
    backgroundImage: `url("${googleImportImg}")`,
  },
  '.card-holder__wrapper .broadMatch_tip_img': {
    backgroundImage: `url("${broadMatchModifierImg}")`,
  },
  '.card-holder__wrapper .exta_tip_img': {
    backgroundImage: `url("${expandedTextAdsImg}")`,
  },
  '.card-holder__wrapper .sitelinks_tip_img': {
    backgroundImage: `url("${sitelinkExtensionsImg}")`,
  },
  '.card-holder__wrapper .callouts_tip_img': {
    backgroundImage: `url("${calloutExtensionsImg}")`,
  },
  '.card-holder__wrapper .structSnip_tip_img': {
    backgroundImage: `url("${structuredSnippetsImg}")`,
  },
  '.card-holder__wrapper .dsa_tip_img': {
    backgroundImage: `url("${dynamicSearchAdsImg}")`,
  },
  '.card-holder__wrapper .conversionTracking_tip_img': {
    backgroundImage: `url("${convTrackingImg}")`,
  },
  '.card-holder__wrapper .remarketing_tip_img': {
    backgroundImage: `url("${remarketingImg}")`,
  },
  '.card-holder__wrapper .autoBid_tip_img': {
    backgroundImage: `url("${enhancedCpcAutobidImg}")`,
  },
  '.card-holder__wrapper .sharedBudgets_tip_img': {
    backgroundImage: `url("${sharedBudgetsImg}")`,
  },
  '.card-holder__wrapper .call_tip_img': {
    backgroundImage: `url("${callImg}")`,
  },
  '.card-holder__wrapper .reviews_tip_img': {
    backgroundImage: `url("${reviewExtentionsImg}")`,
  },
  '.card-holder__wrapper .kWMatchType_tip_img': {
    backgroundImage: `url("${kwMatchTypesImg}")`,
  },
  '.card-holder__wrapper .negKW_tip_img': {
    backgroundImage: `url("${negKeywordsImg}")`,
  },
  '.card-holder__wrapper .optiConsult_tip_img': {
    backgroundImage: `url("${microsoftLogoImg}")`,
  },
  '.card-holder__wrapper .welcome_microsoft_logo_tip_img': {
    backgroundImage: `url("${microsoftLogoImg}")`,
  },
  '.card-holder__wrapper .welcome_create_campaign_tip_img': {
    backgroundImage: `url("${createCampaignImg}")`,
  },
  '.card-holder__wrapper .welcome_coaching_tip_img': {
    backgroundImage: `url("${welcomeCoachingImg}")`,
  },
  '.card-holder__wrapper .welcome_coupon_tip_img': {
    backgroundImage: `url("${welcomeCouponImg}")`,
  },
  '.card-holder__wrapper .welcome_add_payment_tip_img': {
    backgroundImage: `url("${welcomeAddPaymentImg}")`,
  },
  '.card-holder__wrapper .welcome_help_tip_img': {
    backgroundImage: `url("${welcomeHelpImg}")`,
  },
  '.card-holder__wrapper .addNewAds_opportunity_img': {
    backgroundImage: `url("${addNewAdsImg}")`,
  },
  '.card-holder__wrapper .remarketingBid_opportunity_img': {
    backgroundImage: `url("${remarketingBidImg}")`,
  },
  '.card-holder__wrapper .locationBid_opportunity_img': {
    backgroundImage: `url("${locationBidImg}")`,
  },
  '.card-holder__wrapper .keyword_opportunity_img': {
    backgroundImage: `url("${addNewKeywordImg}")`,
  },
  '.card-holder__wrapper .keywordBidAdjustment_opportunity_img': {
    backgroundImage: `url("${keywordBidImg}")`,
  },
  '.card-holder__wrapper .googleImport_opportunity_img': {
    backgroundImage: `url("${googleAdImportImg}")`,
  },
  '.card-holder__wrapper .sitelink_opportunity_img': {
    backgroundImage: `url("${sitelinkExtensionImg}")`,
  },
  '.card-holder__wrapper .callout_opportunity_img': {
    backgroundImage: `url("${calloutExtensionImg}")`,
  },
  '.card-holder__wrapper .budget_opportunity_img': {
    backgroundImage: `url("${budgetOppoImg}")`,
  },
  '.card-holder__wrapper .broadMatchKeyword_opportunity_img': {
    backgroundImage: `url("${kwBroadMatchImg}")`,
  },
  '.card-holder__wrapper .broadMatchModifierKeyword_opportunity_img': {
    backgroundImage: `url("${kwBroadMatchModifierImg}")`,
  },
  '.card-holder__wrapper .firstPage_opportunity_img': {
    backgroundImage: `url("${firstpageOppoImg}")`,
  },
  '.card-holder__wrapper .mainLineBid_opportunity_img': {
    backgroundImage: `url("${mainlineOppoImg}")`,
  },
  '.card-holder__wrapper .mainLine1Bid_opportunity_img': {
    backgroundImage: `url("${firstPositionImg}")`,
  },
  '.card-holder__wrapper .competitiveBid_opportunity_img': {
    backgroundImage: `url("${competitiveBidImg}")`,
  },
  '.card-holder__wrapper .adScheduling_opportunity_img': {
    backgroundImage: `url("${adSchedulingImg}")`,
  },
  '.carouselItemCount': {
    position: 'absolute',
    bottom: '15px',
    right: '70px',
  },
});
